import React from 'react'
import styled, { css } from 'styled-components'
import { FooterSocial } from '../FooterSocial/FooterSocial'
import { Accessibility } from '../_svgs/Accessibility/Accessibility'

export const FooterBottomSection = () => {
  return (
    <FooterBottomSectionRow>
      <FooterBottomSectionContainer>
        <FooterBottomSectionSocialColumn>
          <FooterSocial />
        </FooterBottomSectionSocialColumn>
        <FooterBottomSectionDetailsColumn>
          <Details>
            *Some exclusions apply.{' '}
            <DetailsLink
              data-target='see-details'
              className='cTest_footer_see-details'
              href='/pages/landing-pages-promotions'
            >
              See Details
            </DetailsLink>
          </Details>
          <FooterBottomInformation>
            <PrivacySection>
              <Copyright>&copy; {new Date().getFullYear()} Swanson</Copyright>
              <LinksContainer>
                <CopyrightLink
                  data-target='terms-of-service'
                  className='cTest_footer_terms-of-service footer-link'
                  href='/pages/terms-of-service'
                >
                  Terms of Service
                </CopyrightLink>
                <CopyrightLink
                  data-target='privacy-policy'
                  className='cTest_footer_privacy-policy'
                  href='/pages/security-and-privacy-information'
                >
                  Privacy Policy
                </CopyrightLink>
                <CopyrightLink
                  data-target='sitemap'
                  className='cTest_footer_sitemap'
                  href='/q'
                >
                  Sitemap
                </CopyrightLink>
              </LinksContainer>
            </PrivacySection>
            <IconsSection>
              <AccessibilityA
                data-target='accessiblity-icon'
                className='cTest_footer_accessiblity-icon'
                href='#'
                title='Accessiblity Icon'
              >
                <Accessibility
                  classes='accessibility-icon'
                  width={30}
                  styles={css`
                    @media (max-width: 1280px) {
                      margin: 0 !important;
                    }
                  `}
                />
              </AccessibilityA>
              <BBBContainer
                  href='/help/company-accolades/accolades/awards-achievements.html'
                  aria-label='Awards & Accolades'
              >
                <FooterImage
                  src='https://media.swansonvitamins.com/images/asset/landing-page/icon/HP_Footer_BBB.png'
                  alt='BBB'
                />
              </BBBContainer>
              <ULCertifiedContainer
                  href='/pages/quality-control'
                  aria-label='Quality control guarantees - UL'
              >
                <FooterImage
                  src='https://media.swansonvitamins.com/images/asset/image/website/UL_Certified.png'
                  alt='UL Certified'
                />
              </ULCertifiedContainer>
              <NSFContainer
                  href='/pages/quality-control'
                  aria-label='Quality control guarantees - NSF'
              >
                <FooterImage
                    src='https://media.swansonvitamins.com/images/asset/homepage/hero/Footer_NSF_GMPCertified_050525.jpg'
                    alt='NSF - GMP Certified'
                />
              </NSFContainer>
            </IconsSection>
          </FooterBottomInformation>
          <Disclaimer>
            These statements have not been evaluated by the Food and Drug Administration. These products are not intended to diagnose, treat, cure, or prevent any disease.
          </Disclaimer>
        </FooterBottomSectionDetailsColumn>
      </FooterBottomSectionContainer>
    </FooterBottomSectionRow>
  )
}

const FooterBottomSectionRow = styled.div`
  background-color: ${(props) => props.theme.darkGreen};
  display: flex;
  align-items: center;
  @media (min-width: 768px) {
    border-bottom: 1px solid rgba(217, 217, 217, 0.5);
  }
`

const FooterBottomSectionContainer = styled.div`
  display: flex;
  align-items: flex-start;
  max-width: 1420px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 56px;
  padding-top: 40px;
  @media (max-width: 1420px) {
    padding-left: 15px;
    padding-right: 15px;
  }
  @media (max-width: 1280px) {
    flex-direction: column;
    padding-bottom: 80px;
    padding-top: 15px;
    gap: 25px;
  }
`

const FooterBottomSectionSocialColumn = styled.div`
  display: flex;

  @media (min-width: 768px) {
    width: 25%;
  }
`

const FooterBottomSectionDetailsColumn = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    width: 75%;
  }
`

const Details = styled.p`
  color: ${(props) => props.theme.white};
  font-size: 16px;
  line-height: 1;
  margin-bottom: 12px;
  margin-top: 0 !important;
  @media (max-width: 1280px) {
    margin-bottom: 23px;
  }
  @media (min-width: 1420px) {
    font-size: 18px;
  }
`

const Disclaimer = styled(Details)`
  padding-top: 2.4rem;
`

const DetailsLink = styled.a`
  color: ${(props) => props.theme.white} !important;
  font-size: 14px;
  line-height: 1;
  text-decoration: underline !important;
  text-decoration-thickness: 1px !important;
  text-underline-offset: 3px;
  transition: color 0.15s ease-in-out;
  @media (min-width: 1420px) {
    font-size: 18px;
  }
  &:hover {
    color: ${(props) => props.theme.white} !important;
    text-decoration: none !important;
  }
`

const CopyrightLink = styled.a`
  color: ${(props) => props.theme.white} !important;
  font-size: 14px;
  line-height: 1;
  text-decoration: underline !important;
  text-decoration-thickness: 1px !important;
  text-underline-offset: 3px;
  transition: color 0.15s ease-in-out;
  &:hover {
    color: ${(props) => props.theme.white} !important;
    text-decoration: none !important;
  }
  padding-left: 20px;
  padding-right: 20px;
  border-left: 1px solid rgba(217, 217, 217, 0.5);
  @media (min-width: 1420px) {
    font-size: 18px;
  }
  @media (max-width: 767px) {
    &:first-child {
      padding-left: 0;
      border-left: none;
    }
  }
`

const Copyright = styled.p`
  color: ${(props) => props.theme.white};
  font-size: 14px;
  margin-bottom: 0;
  padding-right: 20px;
  margin-top: 0;
  @media (max-width: 767px) {
    margin-top: 20px;
  }
  @media (min-width: 1420px) {
    font-size: 18px;
  }
`

const PrivacySection = styled.div`
  display: flex;
  @media (max-width: 767px) {
    margin-bottom: 20px;
    flex-direction: column-reverse;
  }
  @media (min-width: 768px) {
    margin-bottom: 20px;
  }
`

const IconsSection = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: -14px;
  @media (max-width: 1280px) {
    margin-top: 0;
  }
  @media (max-width: 767px) {
    flex-wrap: wrap;
  }
`

const FooterBottomInformation = styled.div`
  display: flex;
  align-items: flex-start;
  @media (max-width: 1280px) {
    flex-direction: column;
  }
`

const LinksContainer = styled.div`
  display: flex;
  align-items: center;
`

const BBBContainer = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  text-decoration: none;
`

const ULCertifiedContainer = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 50px;
  text-decoration: none;
`

const NSFContainer = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 37.5px;
  height: 50px;
  text-decoration: none;
`

const AccessibilityA = styled.a`
  @media (max-width: 767px) {
    display: flex;
    width: 100%;
    justify-content: flex-start;
    margin-bottom: 8px;
  }
`

const FooterImage = styled.img`
  max-width: 100%;
  max-height: 50px;
`